import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Button, FormHelperText, Stack, TextField } from '@mui/material';
import type { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import type { ResetPasswordFormType } from '~/types/ResetPassword';
import { ResetPasswordFormSchema } from '~/types/ResetPassword';
import type { ResetPasswordFormProps } from './ResetPasswordForm.types';

export const ResetPasswordForm: FC<ResetPasswordFormProps> = ({ isPending, onSubmit }) => {
  const { handleSubmit, control } = useForm<ResetPasswordFormType>({
    defaultValues: {
      password: '',
      confirmPassword: ''
    },
    resolver: zodResolver(ResetPasswordFormSchema)
  });

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={4.75}>
        <Controller
          name="password"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <Box>
              <TextField
                {...field}
                error={!!error}
                label="Password"
                variant="outlined"
                size="medium"
                fullWidth
                type="password"
              />
              {error && error.message ? (
                <Box px={1.75} pt={0.375}>
                  <FormHelperText error>{error.message}</FormHelperText>
                </Box>
              ) : null}
            </Box>
          )}
        />

        <Controller
          name="confirmPassword"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <Box>
              <TextField
                {...field}
                error={!!error}
                label="Confirm Password"
                variant="outlined"
                size="medium"
                fullWidth
                type="password"
              />
              {error && error.message ? (
                <Box px={1.75} pt={0.375}>
                  <FormHelperText error>{error.message}</FormHelperText>
                </Box>
              ) : null}
            </Box>
          )}
        />

        <Button size="large" color="primary" variant="contained" type="submit" fullWidth>
          {isPending ? 'Submitting...' : 'Submit'}
        </Button>
      </Stack>
    </Box>
  );
};
